import { Component, EventEmitter, Output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';

@Component({
  selector: 'app-certificat-attente',
  standalone: true,
  imports: [IonIcon],
  templateUrl: './certificat-attente.component.html',
  styleUrls: ['./certificat-attente.component.scss']
})
export class CertificatAttenteComponent {
  @Output() refresh = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  isRefreshing = false;

  async onRefresh() {
    this.isRefreshing = true;
    this.refresh.emit();
    setTimeout(() => this.isRefreshing = false, 1500);
  }
}
